

















































































































































import isMobile from 'piramis-js-utils/lib/isMobile'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'
import draggable from 'vuedraggable'

import Tags from '../../../../Tags/Tags.vue'
import { MessageEditorComponentSettings } from "../../../types";
import { BaseButton } from '../Buttons/types'
import ButtonsManager from '../logic/ButtonsManager'

@Component({
  components: {
    draggable,
    Tags,
  }
})
export default class KeyboardButtonsPositionSettings extends Vue {
  @Prop() buttons!: Array<Array<BaseButton>>

  @Prop() buttonsManager!: ButtonsManager

  @Prop() emptyKeyboardInfo!: MessageEditorComponentSettings['emptyKeyboardInfo']

  dragging = false

  get draggableOptions() {
    if (isMobile()) {
      return {
        delay: 120
      }
    }

    return {}
  }

  @Emit()
  closeModal(): this {
    return this
  }

  checkRow(rowGuid: string): void {
    const row = this.buttonsManager.getRow(rowGuid)

    if (row && !row.buttons.length) {
      this.buttonsManager.removeRow(rowGuid)
    }
  }

  dragRowEvent(): void {
    this.buttonsManager.unselectButton()
    this.buttonsManager.updateButtons()
  }

  dragButtonStart(): void {
    this.dragging = true

    this.buttonsManager.unselectButton()
    this.buttonsManager.updateButtons()
  }

  dragButtonEnd(): void {
    this.dragging = false

    this.buttonsManager.unselectButton()
    this.buttonsManager.updateButtons()
  }

  getButtonColor(button: BaseButton): string {
    if (this.buttonsManager.selectedButton && this.buttonsManager.selectedButton.guid === button.guid) {
      return 'rgba(105, 183, 68, 0.3)'
    }

    return ''
  }

}
